<template>
  <div
    id="jqImg4"
    class="domePrint colorBack"
    v-watermark="{
      text: appMobilePhone,
      textColor: 'rgba(180, 180, 180, 0.3)',
    }"
    :class="{ isChildBackground: inquiryInfo.IsChild == 1 }"
  >
    <div class="register colorBack">
      <span>{{ "医疗机构执业许可证登记号：" + inquiryInfo.LicenceNo }}</span>
    </div>
    <div class="title">
      <div class="bianju">
        <!-- <div class="hospitalName colorBack">{{ inquiryInfo.EntityName }}</div> -->
        <div class="hospitalOpen colorBack">{{ inquiryInfo.TitleName | chickName(inquiryInfo.IsChild) }}</div>
      </div>
      <div class="ordinary">
        <div>
          <div class="putong colorBack" v-if="!inquiryInfo.IsChild">{{inquiryInfo.CNDrugsType ==3?'中药':'普通'}}</div>
          <div class="putong colorBack" v-else>儿科普通</div>
          <div class="colorBack">药品处方</div>
        </div>
      </div>
    </div>
    <div class="payOff colorBack">
      <div class="payOff_item">
        <div class="margin-left titleColor">费别：</div>
        <div class="flex1 m-r" style="width: 80px">
          <div>
            <span class="icon iconfont f10">&#xe65f;</span>
            <label class="titleColor f10">公费</label>
            <br />
            <span class="icon iconfont f10">&#xe65f;</span>
            <label class="titleColor f10">医保</label>
          </div>
          <div>  
            <span class="icon iconfont f10">&#xe65f;</span>
            <label class="titleColor f10">自费</label>
            <br />
            <span class="icon iconfont f10">&#xe65f;</span>
            <label class="titleColor f10">其他</label>
          </div>
        </div>
      </div>
      <div class="payOff_item">
        <div class="m-r titleColor">
          {{ "卡号：" + inquiryInfo.InquiryId }}
        </div>
        <div class="m-r titleColor">
          {{ "处方编号：" + inquiryInfo.OrderId }}
        </div>
      </div>
    </div>
    <div class="posionInfo posionInfo_space">
      <div class="flex1 margin-left mtb colorBack">
        <div class="widthStr280 flex1 colorBack">
          <div class="lableStr colorBack">姓名：</div>
          <div class="name colorBack pL20">{{ inquiryInfo.Name }}</div>
        </div>
        <div class="flex2 widthStr340 colorBack">
          <div class="m-r lableStr colorBack">
            <span class="colorBack">性别：</span>
            <span class="icon iconfont f10" v-if="inquiryInfo.Sex == 2"
              >&#xe65f;</span
            >
            <span class="icon iconfont f10" v-else>&#xe64f;</span>
            <span class="colorBack pr5 f10">男</span>
            <span class="icon iconfont f10" v-if="inquiryInfo.Sex == 1"
              >&#xe65f;</span
            >
            <span class="icon iconfont f10" v-else>&#xe64f;</span>
            <span class="colorBack f10">女</span>
          </div>
          <div class="flex1 widthStr m-r">
            <div class="lableStr colorBack">年龄：</div>
            <div class="age colorBack pL5" style="white-space: nowrap">
              {{ inquiryInfo.AgeStr }}
            </div>
          </div>
          <div class="flex1 widthStr" v-show="inquiryInfo.IsChild&&inquiryInfo.CNDrugsType !=3">
            <div class="lableStr colorBack">体重：</div>
            <div class="age colorBack pL5" style="white-space: nowrap">
              {{ inquiryInfo.Weight }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="widthStr280 flex1">
          <div class="lableStr colorBack">问诊/住院病例号：</div>
          <div class="name colorBack" style="font-size: 14px">
            {{ inquiryInfo.InquiryId }}
          </div>
        </div>
        <div class="widthStr340">
          <div class="flex1">
            <div class="lableStr colorBack">科别（病区/床号）：</div>
            <div class="age colorBack tac">{{ inquiryInfo.Department }}</div>
          </div>
        </div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="lableStr colorBack">临床诊断：</div>
        <div class="name colorBack" style="font-weight: 500;">{{ inquiryInfo.Diseases }}</div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="widthStr280 flex1">
          <div class="lableStr colorBack">肝功能异常：</div>
          <div class="name colorBack pL20">{{ inquiryInfo.LiverType  }}</div>
        </div>
        <div class="widthStr340">
          <div class="flex1">
            <div class="lableStr colorBack">肾功能异常：</div>
            <div class="age colorBack pL40">{{ inquiryInfo.RenalType }}</div>
          </div>
        </div>
      </div>
      <div class="flex1 margin-left mtb">
        <div class="widthStr280 flex1">
          <div class="lableStr colorBack">过敏史：</div>
          <div class="name colorBack pL40">{{ inquiryInfo.AMHType }}</div>
        </div>
        <div class="widthStr340 flex1" v-if="inquiryInfo.IsChild!=1 && inquiryInfo.Sex == 2">
          <div class="lableStr colorBack">备孕、妊娠、哺乳：</div>
          <div class="name colorBack pL40">{{ inquiryInfo.NurseType }}</div>
        </div>
      </div>
     
    </div>
    <div class="drugInfo">
      <div class="margin-left">
        <div class="rp">RP</div>
        <!-- 西药 -->
        <div v-if="!_deptCode">
          <div v-for="(item, i) in inquiryInfo.DrugsList" :key="i" style="padding-bottom: 10px;">
            <div class="flex1">
              <div class="colorBack">
                <span>{{ item.Name }}</span> 
                <span class="pL40">{{ item.Specs }}</span>
              </div>
              <div class="colorBack" style="margin-right: 30px;">{{ item.Count }}{{ item.Unit }}</div>
            </div>
            <div class="colorBack">
              用法用量：{{ item.Usage }}，{{ item.Frequency }}
            </div>
          </div>
        </div>
        <!-- 中药 -->
        <div v-if="_deptCode">
          <div v-for="(item, i) in inquiryInfo.DrugsList" :key="i">
            <div class="colorBack f12"  v-if="chackB(item)">{{ item.Name }}</div>
            <div class="chinese-medicine-grid">
              <div
                class="colorBack medicine-item f12"
                v-for="uitem in inquiryInfo.useCNDrugsList"
                :key="uitem.Id"
              >
                {{ uitem.Name }}
                <span
                  class="colorBack lo_decoction_tip "
                  :class="{ lo_p_decoction_tip: uitem.Decoction }"
                  >{{ uitem.Decoction || "" }}</span
                >
                {{ uitem.Count }}{{ uitem.Unit }}
              </div>
            </div>
            <div class="colorBack">
              用法用量：{{ item.Usage }}，{{ item.Frequency }}
            </div>
            <div class="colorBack">总量：{{ item.Count }}{{ item.Unit }}</div>
          </div>
        </div>
      </div>
      <div class="blank margin-left">
        <span class="colorBack">以下空白</span>
        <div class="oksize colorBack" v-if="inquiryInfo.AuditStampUrl">
          <img :src="inquiryInfo.AuditStampUrl" alt width="134" />
        </div>
      </div>
      <div v-if="inquiryInfo.Notice" style="position:absolute;bottom:4px">
        <span class="colorBack">备注：{{ inquiryInfo.Notice}}</span>
      </div>
    </div>
    <div class="posionInfo">
      <div class="flex1 mtb">
        <!-- 医师 -->
        <div class="flex2 widthStr3">
          <div class="lableStr colorBack">医师：</div>
          <div class="name tonSize sing_box">
            <span class="f14" style="color:black">{{
              inquiryInfo.DoctorName
            }}</span>
            <img
              v-if="
                inquiryInfo.DoctorNameUrl &&
                  inquiryInfo.DoctorNameUrl.length > 0
              "
              :src="inquiryInfo.DoctorNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
        <!-- 药师 -->
        <div class="flex2 widthStr3">
          <div class="lableStr colorBack">药 师：</div>
          <div class="name tonSize sing_box">
            <span class="f14" style="color:black">{{ inquiryInfo.PharmacistName }}</span>
            <img
              v-if="
                inquiryInfo.HospPharNameUrl &&
                  inquiryInfo.HospPharNameUrl.length > 0
              "
              :src="inquiryInfo.HospPharNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
        <!-- 药品金额 -->
        <!-- <div class="flex2 widthStr4">
            <div class="lableStr colorBack">调配药师/士：</div>
            <div class="name tonSize">
              <img
                v-if="
                  inquiryInfo.PharDispensingNameUrl &&
                  inquiryInfo.PharDispensingNameUrl.length > 0
                "
                :src="inquiryInfo.PharDispensingNameUrl"
                width="70"
                height="25"
              />
              <img v-else class="visibility" width="70" height="25" />
            </div>
          </div> -->
        <div class="flex1 widthStr3">
          <div class="lableStr colorBack">药品金额：</div>
          <div class="name tonSize sing_box">
            <span class="f14 visibility">无</span>
            <img width="70" height="25" class="visibility" />
          </div>
        </div>
      </div>
      <div class="flex1 mtb">
        <div class="widthStr3">
          <div class="flex1">
            <div class="lableStr colorBack">审核药师：</div>
            <div class="name tonSize sing_box">
              <span class="f14 visibility">无</span>
              <img
                v-if="
                  inquiryInfo.PharAuditNameUrl &&
                    inquiryInfo.PharAuditNameUrl.length > 0
                "
                :src="inquiryInfo.PharAuditNameUrl"
                width="70"
                height="25"
              />
              <img v-else class="visibility" width="70" height="25" />
            </div>
          </div>
        </div>
        <div class="flex2 widthStr3">
          <div class="lableStr colorBack">调配药师/士：</div>
          <div class="name tonSize sing_box">
            <span class="f14 visibility">无</span>
            <img
              v-if="
                inquiryInfo.PharDispensingNameUrl &&
                  inquiryInfo.PharDispensingNameUrl.length > 0
              "
              :src="inquiryInfo.PharDispensingNameUrl"
              width="70"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
        <div class="widthStr3 flex2">
          <div class="lableStr colorBack">复核/发药药师：</div>
          <div class="name tonSize sing_box">
            <span class="f14 visibility">无</span>
            <img
              v-if="
                inquiryInfo.PharReviewNameUrl &&
                  inquiryInfo.PharReviewNameUrl.length > 0
              "
              :src="inquiryInfo.PharReviewNameUrl"
              width="80"
              height="25"
            />
            <img v-else class="visibility" width="70" height="25" />
          </div>
        </div>
      </div>
    </div>
    <div class="data">
      <span class="colorBack">开具日期：</span>
      <span class="heng colorBack">{{ getYear(inquiryInfo.ExpiredTime) }}</span>
      <span class="colorBack">年</span>
      <span class="heng colorBack">{{
        getMonth(inquiryInfo.ExpiredTime)
      }}</span>
      <span class="colorBack">月</span>
      <span class="heng colorBack">{{ getDay(inquiryInfo.ExpiredTime) }}</span>
      <span class="colorBack">日</span>
    </div>
    <div class="explain">
      <span class="colorBack visibility">
        <span style="margin-right: 5px">本处方仅限患者在</span>
        {{ inquiryInfo.CompanyName }}
        <span style="margin-left: 5px">使用</span>
      </span>
      <img
        v-if="inquiryInfo.StampType == 1"
        class="imgStr"
        :src="inquiryInfo.HospitalStampUrl"
        alt
      />
      <img
        v-if="inquiryInfo.StampType == 2"
        class="imgStr_yuang"
        :src="inquiryInfo.HospitalStampUrl"
        alt
      />
    </div>
    <div style="padding-top:10px">
      <span class="colorBack"
     
        >注意： 医师处方有效期为{{
          inquiryInfo.ValidDay
        }}天(医师注明除外）</span
      >
    </div>
  </div>
</template>

<script>
import "@/utils/jquery.jqprint-0.3";
export default {
  components: {},
  props: {
    inquiryInfo: {
      type: [Object, Array],
      default: {},
    },
    _deptCode: {
      type: [String, Boolean],
      default: false,
    },
    appMobilePhone: {
      type: String,
      default: "",
    },
  },
  filters: {
    chickName(name, isChild) {
      let cText = ``;
      if (isChild == 1) {
        cText = "儿童";
      }
      let baseName = name.replace('处方笺','')
      return `${baseName}${cText}处方笺`;
    },
    noticesDesc(inquiryNotices) {
      return inquiryNotices;
    },
  },
  data() {
    return {};
  },
  methods: {
    chackB(item){
      if(!item.UpcCode) return false
      return item.UpcCode.charAt(0) != 'B';
    },
    getYear(dateString) {
      if (!dateString) return "";
      if (dateString.includes("年")) {
        // 处理 "2025年09月15日" 格式
        return dateString.split("年")[0];
      }
    },
    getMonth(dateString) {
      if (!dateString) return "";
      if (dateString.includes("年") && dateString.includes("月")) {
        // 处理 "2025年09月15日" 格式
        let parts = dateString.split("年")[1].split("月");
        return parts[0];
      }
      return "";
    },
    getDay(dateString) {
      if (!dateString) return "";
      if (dateString.includes("月") && dateString.includes("日")) {
        // 处理 "2025年09月15日" 格式
        let parts = dateString.split("月");
        return parts[1].replace("日", "");
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.domePrint {
  text-align: left;
  background: #ffffff;
  padding: 20px;
  width: 700px;
  height: 1000px;
  margin: auto;
  .rp {
    font-size: 30px;
    color: black;
  }
  .visibility {
    visibility: hidden;
  }
  .titleColor {
    color: black;
    font-size: 12px;
  }
  .colorBack {
    color: black;
    font-size: 12px;
  }
  .flex_d {
    width: 700px;
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
  }
  .flex_d_item {
    flex: 0 0 33%;
  }
  .margin-left {
    margin-left: 20px;
    // margin-right: 20px;
  }
  .data {
    padding: 8px 0px;
    .heng {
      border-bottom: 1px solid black;
      padding: 0px 5px;
    }
  }
  .widthStr280 {
    width: 280px;
  }
  .widthStr340 {
    width: 340px;
  }
  .widthStr {
    width: 300px;
  }
  .widthStr1 {
    width: 322px;
  }
  .widthStr2 {
    width: 280px;
  }
  .widthStr3 {
    width: 200px;
  }
  .widthStr4 {
    width: 250px;
  }
  .m-r {
    margin-right: 10px;
  }
  .explain {
    padding-bottom: 5px;
    border-bottom: 1px solid black;
    font-size: 15px;
    padding-left: 5px;
    position: relative;
    .imgStr_yuang {
      max-width: 290px;
      position: absolute;
      top: -71px;
      right: -37px;
    }

    .imgStr {
      max-width: 250px;
      position: absolute;
      top: -80px;
      right: 0px;
    }
  }
  .drugInfo {
    padding-bottom: 15px;
    border-bottom: 1px solid black;
    position: relative;
    min-height: 420px;
    .blank {
      border-top: 1px solid black;
      width: 50%;
      // margin-top: 15px;
      padding: 5px;
      text-align: center;
      // margin-bottom: 100px;
      .oksize {
        position: absolute;
        right: 100px;
        bottom: 20px;
        .okName {
          position: absolute;
          top: 15px;
          left: 50px;
          color: red;
          font-weight: bold;
        }
        .okData {
          position: absolute;
          bottom: 16px;
          left: 30px;
          color: red;
          font-weight: bold;
        }
      }
    }
  }
  .posionInfo_space {
    padding-bottom: 15px;
    border-bottom: 1px solid black;
  }
  .posionInfo {
    .mtb {
      padding-top: 10px;
    }
    .lableStr {
      width: auto;
      white-space: nowrap;
      align-self: self-end;
    }

    .name {
      width: 100%;
      border-bottom: 1px solid black;
    }
    .tonSize {
      width: 100%;
    }
    .age {
      width: 100%;
      border-bottom: 1px solid black;
    }

    .lastTonSize {
      width: 200px;
    }
  }
  .payOff {
    display: flex;
    justify-content: space-between;
    justify-items: start;
    align-items: flex-end;
    border-bottom: 1px solid black;
    padding-bottom: 5px;
  }
  .payOff_item {
    display: flex;
    justify-items: start;
    align-items: flex-end;
    // border-bottom: 1px solid black;
    // padding-bottom: 5px;
  }
  .register {
    font-size: 12px;
    color: black;
  }
  .title {
    margin: 30px 0 10px 0;
    text-align: center;
    position: relative;
  }
  .ordinary {
    position: absolute;
    top: 20px;
    right: 28px;
    font-size: 12px;
    border: 1px solid black;
    padding: 1px 2px;
    border-radius: 5px;
    line-height: 16px;
    .putong {
      width: 100%;
      text-align: justify;
      text-align-last: justify;
    }
  }
  .bianju {
    line-height: 80px;
  }
  .hospitalName {
    font-size: 23px;
    font-weight: bold;
  }
  .hospitalOpen {
    font-size: 29px;
    font-weight: bold;
  }
}
// .isChildBackground {
//   background: #c9fee0;
// }
.sing_box {
  position: relative;
  span {
    white-space: nowrap;
  }
  img {
    position: absolute;
    right: 12%;
    top: -10px;
  }
}
.chinese-medicine-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding-left: 15px;
//   gap: 10px;
}
.medicine-item {
  height: 30px;
  //   padding: 0 5px;
}
.f12 {
  font-size: 12px !important;
}
.lo_decoction_tip {
  display: inline-block;
  white-space: nowrap;
  font-size: 8px !important;
  height: 22px;
  vertical-align: bottom;
}
.iconfont{
  font-size: 12px;
  margin-right: 2px;
}
.pL20{
  padding-left: 20px;  
}
.pL40{
  padding-left: 40px;  
}
.pL5{
  padding-left: 5px;  
}
.pr5{
  padding-right: 5px;  
}
.tac{
  text-align: center;
}
.f10{
  font-size: 10px;
}
</style>
